/* ============================================================
   snf-slot-machine.js  -  drives sections/spin-to-win.liquid

   The reel engine (calcFT / doTick / startReel / stopReel / tension /
   particles) is carried over VERBATIM from the old file. It is good and it
   was not the problem. Everything around it changed:

     WAS                                  NOW
     injected its own <section>           mounts into #snfslMount
     8KB of CSS in a JS string            assets/snf-slot-machine.css
     roller = 0.3% jackpot                roller = 12% (set in the section)
     "prize" -> /cart/add.js FULL PRICE   prize -> single-use discount code
     sold 3 spins for GBP 1               spins earned with an email
     30,309 bytes - unwritable via API    under the ~22KB ceiling

   *** THE PRIZE MUST NEVER BE ADDED TO THE CART ***
   The old code called /cart/add.js on a win. That put the roller in the cart
   at full price - the customer was told they had won and then charged 45-50
   GBP. There is deliberately no cart call anywhere in this file. The prize is
   a discount code minted by the Worker. If you find yourself adding a
   /cart/add.js call to a win path, stop.

   *** NO PAID SPINS ***
   Selling randomised chances for money is a gambling mechanic, and this is a
   German-based business with near-miss animations coded in. Do not add a
   buy-spins button back without legal advice.
   ============================================================ */
(function(){
'use strict';

var root=document.getElementById('snfSlotSection');
if(!root)return;
var mount=document.getElementById('snfslMount');
if(!mount||mount.childNodes.length)return;

/* ---- config, from the section settings ---- */
function num(k,d){var v=parseFloat(root.getAttribute(k));return isNaN(v)?d:v;}
var ENDPOINT=root.getAttribute('data-endpoint')||'';
var PRIVACY=root.getAttribute('data-privacy-url')||'';
var START_SPINS=num('data-start-spins',3);
var MAX_SPINS=num('data-max-spins',10);
var P_ROLLER=num('data-odds-roller',12)/100;
var ORDERS=parseInt(root.getAttribute('data-orders')||'0',10);if(isNaN(ORDERS)||ORDERS<0)ORDERS=0;

var SVGS=(window.SNF_SLOT||{}).SVGS;
var SYM=(window.SNF_SLOT||{}).SYM;
if(!SVGS||!SYM)return;

var LS='snfSlot6', LSE='snfSlotEmail';
var spins=parseInt(localStorage.getItem(LS)||'0',10);
if(isNaN(spins)||spins<0)spins=0;
var savedEmail=localStorage.getItem(LSE)||'';
var totalGranted=parseInt(localStorage.getItem(LS+'T')||'0',10);
if(isNaN(totalGranted)||totalGranted<0)totalGranted=0;

var spinning=false,landedCount=0,spinOutcome=null,spinSyms=[0,0,0],wasNearMiss=false;
var rPos=[0,0,0],rTimers=[null,null,null];
var rStopping=[false,false,false],rStopTick=[0,0,0];
var rTarget=[0,0,0],rFinalTarget=[0,0,0];
var rDone=[false,false,false];
var audioCtx=null;

function save(){try{localStorage.setItem(LS,String(spins));localStorage.setItem(LS+'T',String(totalGranted));}catch(e){}}
function grant(n){var room=Math.max(0,MAX_SPINS-totalGranted);var give=Math.min(n,room);spins+=give;totalGranted+=give;save();updHUD();return give;}

/* ---- build the cabinet ---- */
function mkRow(n,id){
  var row=document.createElement('div');row.className='snfsl-lrow'+(id?' '+id:'');if(id)row.id=id;
  var cs=['#c8a951','#a42325','#c8a951','rgba(244,239,230,.6)','#c8a951','#a42325'];
  for(var i=0;i<n;i++){var b=document.createElement('div');b.className='snfsl-bulb';b.style.cssText='color:'+cs[i%cs.length]+';background:'+cs[i%cs.length]+';animation-delay:'+(i*(0.9/n))+'s';row.appendChild(b);}
  return row;
}
function mkStrip(ri){
  var strip=document.createElement('div');strip.className='snfsl-strip';strip.id='snfslS'+ri;
  for(var c=0;c<10;c++) for(var j=0;j<9;j++){var sym=SYM[j];var d=document.createElement('div');d.className='snfsl-sym';d.style.background=sym.bg;d.innerHTML='<div class="snfsl-si" style="color:'+sym.col+'">'+SVGS[sym.id]+'</div><div class="snfsl-sn" style="color:'+sym.col+'">'+sym.name+'</div>';strip.appendChild(d);}
  return strip;
}

var cab=document.createElement('div');cab.className='snfsl-cab';cab.id='snfslCab';
var brand=document.createElement('div');brand.className='snfsl-brand';brand.textContent='sniff. london';cab.appendChild(brand);
cab.appendChild(mkRow(17,'snfslLT'));
var wr=document.createElement('div');wr.className='snfsl-wr';wr.id='snfslWR';cab.appendChild(wr);
var reelsD=document.createElement('div');reelsD.className='snfsl-reels';
for(var ri=0;ri<3;ri++){var rd=document.createElement('div');rd.className='snfsl-reel';rd.id='snfslR'+ri;rd.appendChild(document.createElement('div')).className='snfsl-rhl';rd.appendChild(mkStrip(ri));reelsD.appendChild(rd);}
cab.appendChild(reelsD);
cab.appendChild(mkRow(17,'snfslLB'));
var hud=document.createElement('div');hud.className='snfsl-hud';
hud.innerHTML='<div class="snfsl-hi"><div class="snfsl-hl">Spins</div><div class="snfsl-hv red" id="snfslFree">'+spins+'</div></div><div class="snfsl-hdiv"></div><div class="snfsl-hi"><div class="snfsl-hl">This Win</div><div class="snfsl-hv" id="snfslWin">&mdash;</div></div><div class="snfsl-hdiv"></div><div class="snfsl-hi"><div class="snfsl-hl">Last</div><div class="snfsl-hv" id="snfslLast">&mdash;</div></div>';
cab.appendChild(hud);

/* ---- gate: email buys the spins. Phone is optional, always. ---- */
var gate=document.createElement('div');gate.className='snfsl-gate';gate.id='snfslGate';
gate.innerHTML=
  '<label for="snfslEmail">Email &mdash; we send your prize here</label>'+
  '<input type="email" id="snfslEmail" placeholder="you@example.com" autocomplete="email">'+
  '<label for="snfslPhone">Mobile (optional)</label>'+
  '<input type="tel" id="snfslPhone" placeholder="Optional" autocomplete="tel">'+
  '<label class="snfsl-consent"><input type="checkbox" id="snfslSms"><span>Text me about drops and pop-ups. Optional &mdash; you get your spins either way.</span></label>'+
  '<div class="snfsl-err" id="snfslErr">Enter a valid email address.</div>'+
  '<button class="snfsl-spin" id="snfslGateBtn" type="button">Get '+START_SPINS+' Spins</button>'+
  '<div class="snfsl-fine">We use your email to send your prize and occasional news. Unsubscribe any time.'+(PRIVACY?' <a href="'+PRIVACY+'">Privacy policy</a>.':'')+'</div>';
cab.appendChild(gate);

var btns=document.createElement('div');btns.className='snfsl-btns';btns.id='snfslBtns';btns.style.display='none';
btns.innerHTML='<button class="snfsl-spin" id="snfslSpinBtn" type="button">SPIN &#9654;</button><div class="snfsl-note" id="snfslNote"></div>';
cab.appendChild(btns);
mount.appendChild(cab);

var ovl=document.createElement('div');ovl.className='snfsl-ovl';ovl.id='snfslOvl';
ovl.innerHTML='<div class="snfsl-modal" id="snfslModal"><button class="snfsl-mc" id="snfslMClose">&times;</button><div class="snfsl-mico" id="snfslMIco"></div><div class="snfsl-mt" id="snfslMt"></div><div class="snfsl-mp" id="snfslMp"></div><div class="snfsl-mb" id="snfslMb"></div><div class="snfsl-code" id="snfslCode"></div><button class="snfsl-ma" id="snfslMa" type="button"></button><button class="snfsl-msk" id="snfslMsk" type="button">Maybe later</button></div>';
document.body.appendChild(ovl);

/* ---- audio ---- */
function ac(){if(!audioCtx)try{audioCtx=new(window.AudioContext||window.webkitAudioContext)();}catch(e){}return audioCtx;}
function pNote(f,t,v,d,dl){var ctx=ac();if(!ctx)return;var o=ctx.createOscillator(),g=ctx.createGain();o.connect(g);g.connect(ctx.destination);o.type=t||'sine';o.frequency.value=f;var st=ctx.currentTime+(dl||0);g.gain.setValueAtTime(v||0.3,st);g.gain.exponentialRampToValueAtTime(0.001,st+d);o.start(st);o.stop(st+d+0.05);}
function playTick(){pNote(600+Math.random()*300,'square',0.06,0.018,0);}
function playStop(i){var f=[180,145,110];pNote(f[i],'sine',0.6,0.14,0);pNote(f[i]*1.5,'sine',0.22,0.1,0.05);}
function playWin(){[523,659,784,1047].forEach(function(f,i){pNote(f,'sine',0.38,0.32,i*0.09);});}
function playJackpot(){[523,659,784,880,1047,1175,1319,1568].forEach(function(f,i){pNote(f,'sine',0.42,0.38,i*0.11);pNote(f/2,'triangle',0.22,0.38,i*0.11);});pNote(261,'sine',0.28,2,0);}
function playFree(){[659,784,988,784,659].forEach(function(f,i){pNote(f,'sine',0.3,0.15,i*0.09);});}
function playNear(){pNote(440,'sawtooth',0.26,0.24,0);pNote(330,'sawtooth',0.2,0.3,0.2);pNote(220,'sawtooth',0.15,0.35,0.42);}
function playTension(){pNote(523,'sine',0.32,0.22,0);pNote(659,'sine',0.32,0.22,0.18);}

/* ---- reel engine: unchanged from the original ---- */
var TCOPY=[3,4,5],TICK=48;
function calcFT(ri,sym){var base=(TCOPY[ri]*9+sym-1)*90;while(base<rPos[ri]+300)base+=810;return base;}
function doTick(ri){
  if(rDone[ri])return;
  rPos[ri]+=90;
  if(!rStopping[ri]&&rPos[ri]>4860){rPos[ri]-=3240;var sp=document.getElementById('snfslS'+ri);if(sp){sp.style.transition='none';sp.style.transform='translateY(-'+rPos[ri]+'px)';sp.getBoundingClientRect();}}
  var sp2=document.getElementById('snfslS'+ri);
  if(sp2){var spd=rStopping[ri]?Math.max(65,160-rStopTick[ri]*20):TICK;sp2.style.transition='transform '+(spd*0.8)+'ms linear';sp2.style.transform='translateY(-'+rPos[ri]+'px)';}
  if(Math.random()<0.3)playTick();
  if(!rStopping[ri]){rTimers[ri]=setTimeout(function(){doTick(ri);},TICK);return;}
  rStopTick[ri]++;
  var dist=rFinalTarget[ri]-rPos[ri];
  if(dist<=90&&rStopTick[ri]>2){clearTimeout(rTimers[ri]);var fp=rFinalTarget[ri];rPos[ri]=fp;var strip=document.getElementById('snfslS'+ri);if(strip){strip.style.transition='transform 220ms cubic-bezier(.2,.85,.4,1)';strip.style.transform='translateY(-'+fp+'px)';}setTimeout(function(){onLanded(ri);},240);return;}
  var nd=dist>540?TICK:dist>270?80:dist>90?140:210;rTimers[ri]=setTimeout(function(){doTick(ri);},nd);
}
function startReel(ri){
  var rd=document.getElementById('snfslR'+ri);if(rd){rd.classList.add('spinning');rd.classList.remove('stopping','landed','win','jackpot');}
  var s0=Math.floor(Math.random()*9);rPos[ri]=(9+s0-1)*90;
  var s=document.getElementById('snfslS'+ri);if(s){s.style.transition='none';s.style.transform='translateY(-'+rPos[ri]+'px)';}
  rTimers[ri]=setTimeout(function(){doTick(ri);},TICK);
}
function stopReel(ri,sym){rFinalTarget[ri]=calcFT(ri,sym);rTarget[ri]=sym;rStopping[ri]=true;rStopTick[ri]=0;var rd=document.getElementById('snfslR'+ri);if(rd){rd.classList.remove('spinning');rd.classList.add('stopping');}}
function triggerTension(){
  var w=document.getElementById('snfslWR');if(w){w.classList.add('on','tension');}
  var c=document.getElementById('snfslCab');if(c)c.classList.add('tension');
  var wEl=document.getElementById('snfslWin');if(wEl){wEl.textContent='\u2026\u2026';wEl.className='snfsl-hv gold';}
  var lt=document.getElementById('snfslLT'),lb=document.getElementById('snfslLB');
  if(lt)lt.classList.add('flash');if(lb)lb.classList.add('flash');
  playTension();
}
function clearTension(){
  var w=document.getElementById('snfslWR');if(w){w.classList.remove('tension');}
  var c=document.getElementById('snfslCab');if(c)c.classList.remove('tension');
  var lt=document.getElementById('snfslLT'),lb=document.getElementById('snfslLB');
  if(lt)lt.classList.remove('flash');if(lb)lb.classList.remove('flash');
}
function shakeScreen(){var s=document.getElementById('snfSlotSection');if(s){s.classList.add('shake');setTimeout(function(){s.classList.remove('shake');},520);}}
function spawnParticles(){
  var cols=['#c8a951','#a42325','#f4efe6','#D4AF37','#C0392B'];var cx=window.innerWidth/2,cy=window.innerHeight*0.4;
  for(var i=0;i<55;i++){var p=document.createElement('div');p.className='snfsl-part';var angle=Math.random()*Math.PI*2,spd=70+Math.random()*240;p.style.cssText='left:'+cx+'px;top:'+cy+'px;background:'+cols[i%cols.length]+';--dx:'+(Math.cos(angle)*spd)+'px;--dy:'+(Math.sin(angle)*spd*0.7-120)+'px;--dr:'+(Math.random()*720-360)+'deg;--dur:'+(0.9+Math.random()*1)+'s;animation-delay:'+(Math.random()*0.12)+'s;';document.body.appendChild(p);setTimeout((function(el){return function(){if(el.parentNode)el.parentNode.removeChild(el);};})(p),2500);}
}
function flashLights(col){
  var lt=document.getElementById('snfslLT'),lb=document.getElementById('snfslLB');
  [lt,lb].forEach(function(row){if(!row)return;row.querySelectorAll('.snfsl-bulb').forEach(function(b){b.style.color=col;b.style.background=col;});row.classList.add('flash');});
  var w=document.getElementById('snfslWR');if(w)w.classList.add('on');
  setTimeout(function(){[lt,lb].forEach(function(row){if(!row)return;row.classList.remove('flash');var cs=['#c8a951','#a42325','#c8a951','rgba(244,239,230,.6)','#c8a951','#a42325'];row.querySelectorAll('.snfsl-bulb').forEach(function(b,i){b.style.color=cs[i%cs.length];b.style.background=cs[i%cs.length];});});if(w)w.classList.remove('on');},3800);
}
function onLanded(ri){
  rDone[ri]=true;var rd=document.getElementById('snfslR'+ri);if(rd){rd.classList.remove('stopping');rd.classList.add('landed');}
  playStop(ri);landedCount++;
  if(landedCount===2&&rDone[0]&&rDone[1]&&spinSyms[0]===spinSyms[1])triggerTension();
  if(landedCount===3){clearTension();setTimeout(evaluate,320);}
}

/* ---- odds. Driven entirely by the section settings. ---- */
function outcome(){
  var r=Math.random();
  if(r<P_ROLLER)return'roller';
  return'lose';
}
function genSyms(oc){
  wasNearMiss=false;var r0,r1,r2;
  if(oc==='roller'){var p=Math.floor(Math.random()*7);r0=r1=r2=p;spinSyms=[p,p,p];}
  else{
    if(Math.random()<0.55){wasNearMiss=true;var nm=Math.floor(Math.random()*8);r0=r1=nm;r2=(nm+1)%9;if(r2===nm)r2=(nm+2)%9;spinSyms=[nm,nm,r2];}
    else{r0=Math.floor(Math.random()*9);do{r1=Math.floor(Math.random()*9);}while(r1===r0);do{r2=Math.floor(Math.random()*9);}while(r2===r0||r2===r1);spinSyms=[r0,r1,r2];}
  }
  return[r0,r1,r2];
}

function doSpin(){
  if(spinning)return;
  if(spins<=0){showOutOfSpins();return;}
  spins--;save();updHUD();spinning=true;landedCount=0;
  rDone=[false,false,false];rStopping=[false,false,false];rStopTick=[0,0,0];rFinalTarget=[0,0,0];
  document.getElementById('snfslSpinBtn').disabled=true;
  document.getElementById('snfslWin').textContent='\u2014';document.getElementById('snfslWin').className='snfsl-hv';
  var w=document.getElementById('snfslWR');if(w){w.classList.remove('on','tension');}
  document.getElementById('snfslCab').classList.remove('tension');
  var oc=outcome();spinOutcome=oc;var syms=genSyms(oc);
  for(var i=0;i<3;i++){clearTimeout(rTimers[i]);startReel(i);}
  (function(s0,s1,s2){setTimeout(function(){stopReel(0,s0);},1600);setTimeout(function(){stopReel(1,s1);},2600);setTimeout(function(){stopReel(2,s2);},3500);})(syms[0],syms[1],syms[2]);
}

function evaluate(){
  spinning=false;document.getElementById('snfslSpinBtn').disabled=false;
  var oc=spinOutcome;
  var winEl=document.getElementById('snfslWin'),lastEl=document.getElementById('snfslLast');

  if(oc==='roller'){
    var sym=SYM[spinSyms[0]];
    playJackpot();flashLights('#c8a951');spawnParticles();
    for(var i=0;i<3;i++){var r=document.getElementById('snfslR'+i);if(r)r.classList.add('jackpot');}
    winEl.textContent=sym.name;winEl.className='snfsl-hv gold';lastEl.textContent='ROLLER';
    showModal(SVGS[sym.id],sym.col,'You won.','FREE '+sym.name+' ROLLER','Free with any roller you buy. Fetching your code\u2026','Shop '+sym.name,function(){window.location.href='/products/'+sym.handle;},true);
    claimPrize('roller',sym.handle,sym.name);
  }
  else{
    var w2=document.getElementById('snfslWR');if(w2)w2.classList.remove('on');
    playNear();lastEl.textContent='MISS';
    if(wasNearMiss){shakeScreen();winEl.textContent='SO CLOSE';setTimeout(function(){winEl.textContent='\u2014';winEl.className='snfsl-hv';},2200);}
    if(spins<=0)setTimeout(showOutOfSpins,900);
  }
  updNote();
  setTimeout(function(){for(var k=0;k<3;k++){var rk=document.getElementById('snfslR'+k);if(rk)rk.classList.remove('jackpot','win','landed');}},5000);
}

/* ---- prize. A single-use discount code, minted server-side.
       NOTHING IS EVER ADDED TO THE CART. See the header. ---- */
function claimPrize(kind,handle,label){
  var codeEl=document.getElementById('snfslCode');
  var bodyEl=document.getElementById('snfslMb');
  if(!ENDPOINT){
    bodyEl.textContent='Free with any roller you buy. We have emailed your code to '+savedEmail+'.';
    return;
  }
  fetch(ENDPOINT,{
    method:'POST',
    headers:{'Content-Type':'application/json'},
    body:JSON.stringify({prize:kind,handle:handle,label:label,email:savedEmail})
  })
  .then(function(r){return r.json();})
  .then(function(d){
    if(d&&d.code){
      codeEl.textContent=d.code;codeEl.classList.add('show');
      bodyEl.textContent='Applied at checkout \u2014 add any two rollers and one is free. Sent to '+savedEmail+' too. Single use, expires 16 Oct.';
      var actBtn=document.getElementById('snfslMa');
      if(actBtn){var dest=handle?('/discount/'+encodeURIComponent(d.code)+'?redirect=/products/'+handle):('/discount/'+encodeURIComponent(d.code)+'?redirect=/collections/all');actBtn.onclick=function(){window.location.href=dest;};}
    }else{
      bodyEl.textContent='Free with any roller you buy. We have emailed your code to '+savedEmail+'.';
    }
  })
  .catch(function(){
    bodyEl.textContent='Free with any roller you buy. We have emailed your code to '+savedEmail+'.';
  });
}

function showOutOfSpins(){
  showModal(SVGS.wild,'#C0392B','Out of spins.','','That is your lot for now. Every order earns 3 more spins.','Shop The Collection',function(){window.location.href='/collections/all';},false);
}
function updHUD(){var el=document.getElementById('snfslFree');if(el)el.textContent=spins;}
function updNote(){
  var n=document.getElementById('snfslNote');if(!n)return;
  n.textContent=spins>0?(spins===1?'1 spin left.':spins+' spins left.'):'No spins left. Every order earns 3 more.';
}
function showModal(svgStr,col,title,prize,body,actionTxt,actionFn,isJkp){
  var modal=document.getElementById('snfslModal');
  var ico=document.getElementById('snfslMIco');
  ico.innerHTML='<svg viewBox="0 0 40 40" fill="none" stroke="'+col+'" stroke-width="1.4" style="filter:drop-shadow(0 0 8px '+col+')">'+svgStr.replace(/<svg[^>]*>/,'').replace('</svg>','')+'</svg>';
  document.getElementById('snfslMt').textContent=title;
  document.getElementById('snfslMp').textContent=prize;
  document.getElementById('snfslMb').textContent=body;
  var codeEl=document.getElementById('snfslCode');codeEl.textContent='';codeEl.classList.remove('show');
  var btn=document.getElementById('snfslMa');btn.textContent=actionTxt;btn.onclick=actionFn;
  if(isJkp)modal.classList.add('jkp');else modal.classList.remove('jkp');
  document.getElementById('snfslOvl').classList.add('show');
}
function closeModal(){document.getElementById('snfslOvl').classList.remove('show');}

/* ---- gate ---- */
function validEmail(v){return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);}
function openMachine(){
  var creditedOrders=parseInt(localStorage.getItem(LS+'O')||'0',10);if(isNaN(creditedOrders)||creditedOrders<0)creditedOrders=0;
  if(ORDERS>creditedOrders){grant(3*(ORDERS-creditedOrders));creditedOrders=ORDERS;try{localStorage.setItem(LS+'O',String(creditedOrders));}catch(e){}}
  document.getElementById('snfslGate').style.display='none';
  document.getElementById('snfslBtns').style.display='flex';
  updHUD();updNote();
}
document.getElementById('snfslGateBtn').addEventListener('click',function(){
  var em=document.getElementById('snfslEmail').value.trim();
  var err=document.getElementById('snfslErr');
  if(!validEmail(em)){err.classList.add('show');return;}
  err.classList.remove('show');
  savedEmail=em;
  try{localStorage.setItem(LSE,em);}catch(e){}
  var phone=document.getElementById('snfslPhone').value.trim();
  var sms=document.getElementById('snfslSms').checked;
  if(ENDPOINT){
    fetch(ENDPOINT,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({action:'signup',email:em,phone:phone,sms_consent:sms})}).catch(function(){});
  }
  grant(START_SPINS);
  openMachine();
});
document.getElementById('snfslSpinBtn').addEventListener('click',doSpin);
document.getElementById('snfslMClose').addEventListener('click',closeModal);
document.getElementById('snfslMsk').addEventListener('click',closeModal);
document.getElementById('snfslOvl').addEventListener('click',function(e){if(e.target===this)closeModal();});

/* returning player: skip the gate */
if(savedEmail&&totalGranted>0)openMachine();

for(var i2=0;i2<3;i2++){var iS=Math.floor(Math.random()*9);rPos[i2]=(9+iS-1)*90;var ist=document.getElementById('snfslS'+i2);if(ist){ist.style.transition='none';ist.style.transform='translateY(-'+rPos[i2]+'px)';}}
updHUD();updNote();

})();
